import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const ApiKeyManager = ({ API_BASE_URL, API_KEY }) => {
    const [apiKey, setApiKey] = useState('');
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchCurrentApiKey();
    }, []);

    const fetchCurrentApiKey = async () => {
        try {
            const token = localStorage.getItem('token'); 
            const response = await axios.get(`${API_BASE_URL}/WhatsAppAuth/current-api-key`, {
                headers: { 
                  'X-API-KEY': API_KEY,
                  Authorization: `Bearer ${token}` 
                }
            });
            if (response.data && response.data.apiKey) {
                setApiKey(response.data.apiKey);
            }
        } catch (error) {
            console.error("Error fetching API key", error);
        }
    };

 const generateKey = async () => {
        // Dynamic Modern SweetAlert Confirmation Box
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to generate a new API key? The old one will stop working!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, generate it!',
            cancelButtonText: 'Cancel'
        }).then(async (result) => {
            // Agar user ne 'Haan' button par click kiya tabhi aage ka process chalega
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    const token = localStorage.getItem('token'); 
                    const response = await axios.post(`${API_BASE_URL}/WhatsAppAuth/generate-api-key`, {}, {
                        headers: { 
                            'X-API-KEY': API_KEY,
                            Authorization: `Bearer ${token}` 
                        }
                    });

                    if (response.data && response.data.success) {
                        setApiKey(response.data.apiKey);
                        
                        // 🎉 Success SweetAlert!
                        Swal.fire({
                            title: 'Success!',
                            text: '🎉 API Key successfully generated!',
                            icon: 'success',
                            confirmButtonColor: '#28a745'
                        });
                    }
                } catch (error) {
                    console.error(error);
                    
                    // ❌ Error SweetAlert!
                    Swal.fire({
                        title: 'Error!',
                        text: '❌ Error generating API Key. Please try again.',
                        icon: 'error',
                        confirmButtonColor: '#d33'
                    });
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(apiKey);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div style={styles.card}>
            <h2>🔌 Developer API Access</h2>
            <p style={{ color: '#666', fontSize: '14px' }}>
               Use this API key to integrate WhatsApp automation with your website or application.
            </p>

            <div style={styles.keyContainer}>
                <input 
                    type="text" 
                    readOnly 
                    value={apiKey ? apiKey : '••••••••••••••••••••••••••••••••••••••••'} 
                    style={styles.inputStyle}
                />
                {apiKey && (
                    <button onClick={copyToClipboard} style={styles.copyButton}>
                        {copied ? '✅ Copied!' : '📋 Copy'}
                    </button>
                )}
            </div>

            <div>
                <button onClick={generateKey} disabled={loading} style={loading ? styles.btnDisabled : styles.btnSuccess}>
                    {loading ? 'Generating...' : apiKey ? '🔄 Regenerate API Key' : '✨ Generate API Key'}
                </button>
            </div>

            {message && <p style={{ marginTop: '15px', color: '#155724', fontWeight: 'bold' }}>{message}</p>}

            <div style={styles.docAlert}>
                <strong>💡 Integration Tip:</strong> Apne third-party HTTP requests ke headers me 
                <span style={{ fontFamily: 'monospace', fontWeight: 'bold', color: '#d63384' }}> X-WA-API-KEY </span> key ke sath is string ko pass karein.
            </div>
        </div>
    );
};

const styles = {
    card: { backgroundColor: '#ffffff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', maxWidth: '700px' },
    keyContainer: { display: 'flex', gap: '10px', marginBottom: '20px', marginTop: '15px' },
    inputStyle: { flex: 1, padding: '10px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#f9f9f9', fontFamily: 'monospace' },
    copyButton: { padding: '0 15px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' },
    btnSuccess: { padding: '12px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' },
    btnDisabled: { padding: '12px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'not-allowed' },
    docAlert: { marginTop: '25px', padding: '15px', backgroundColor: '#e2e3e5', borderRadius: '5px', fontSize: '13px', color: '#383d41', borderLeft: '4px solid #6c757d' }
};

export default ApiKeyManager; // 🔥 Export kiya taaki App.js me use ho sake